module.exports = __webpack_public_path__ + "static/media/menu.6e6889b1.svg";